const $header = $('header.masthead'),
    classHeaderSticky = 'masthead--fixed',
    classHeaderVisible = 'masthead--visible',
    headerVisibleTreshold = viewport().height / 2;

$(window).on('scroll', function () {
    let scrolledDistance = $(document).scrollTop();

    if (scrolledDistance > headerVisibleTreshold) {

        // console.log('Show header');
        $header.css('height', $header.outerHeight());
        $header.addClass(classHeaderSticky).addClass(classHeaderVisible);

    } else if (scrolledDistance <= ($header.outerHeight() * 2)) {

        // console.log('Hide header URGENT');
        $header.removeClass(classHeaderSticky).removeClass(classHeaderVisible);
        $header.css('height', 'auto');

    } else {

        // console.log('Hide header');
        $header.removeClass(classHeaderVisible);

    }
});
